import { Route, Routes } from '@models/routes';
import { reduce, flatten } from 'lodash-es';

export function flattenRoutes(routes: Routes): Routes {
  return reduce(
    routes,
    (result: Routes, route: Route) => {
      if (route.children) {
        const { children, ...rest } = route;
        result.push(rest);
        return flatten([
          ...result,
          flattenRoutes(
            children?.map((item) => ({
              ...item,
              path: [rest.path, item.path].join('/'),
            }))
          ),
        ]);
      }
      result.push(route);
      return result;
    },
    []
  );
}
